import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {gsap} from "gsap";
import {Helper} from "../../../../core/utils/Helper";
import {TextStyleOptions} from "../../../../setting/IText";

export class DebugSoundRow extends PIXI.Container {

    private textName: PIXI.Text;
    private textVolume: PIXI.Text;
    // private textPlaying:PIXI.Text;
    private player: NolimitHowl;

    private bg: PIXI.Graphics;

    private DEFAULT_TEXT_STYLE: TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 10,
        dropShadowDistance: 2,
        fontFamily: "Helvetica",
        fontWeight: FontWeight.BOLD,
        fontSize: 28,
        align: "left",
        wordWrap: true,
        wordWrapWidth: 400,
        fill: [
            "white",
        ]
    };
    private rowID: number;

    public get ID(): number {
        return this.rowID;
    }

    public get soundName(): string {
        return this.player.soundName;
    }

    constructor(player: NolimitHowl) {
        super();

        this.player = player;
        this.CreateOrUpdate();
    }

    public setRowID(value: number): void {
        this.rowID = value;
        this.position.y = 40 + value * 40;
        if (this.bg) {
            this.bg.tint = value % 2 ? 0x033030 : 0x220033, 0.75;
        }
    }

    private removeTL: gsap.core.Timeline;

    public CreateOrUpdate(): void {
        if (!this.textName) {
            this.bg = this.createGraphic(500, 40);
            this.textName = this.addChild(new PIXI.Text(this.soundName + ":", this.DEFAULT_TEXT_STYLE));
            this.textVolume = this.addChild(new PIXI.Text(this.player.currentVolume().toPrecision(2), this.DEFAULT_TEXT_STYLE));
            // this.textPlaying = this.addChild(new PIXI.Text(""+this.player.isPlaying, this.DEFAULT_TEXT_STYLE));
        }

        this.updateValue();

        if (this.isRemoving) {
            this.removeTL = Helper.setTimeline(this.removeTL, new gsap.core.Timeline());
            this.removeTL = null!;
            this.alpha = 1;
        }
    }

    private createGraphic(sizeX: number = 500, sizeY?: number): PIXI.Graphics {
        if (!sizeY) sizeY = sizeX;
        const gfx: PIXI.Graphics = this.addChild(new PIXI.Graphics());
        gfx.clear();
        gfx.beginFill(0xFFFFFF, 1);
        gfx.drawRect(0, 0, sizeX, sizeY);
        gfx.endFill();
        return gfx;
    }

    public updateValue(): void {
        this.textVolume.text = "Volume: " + this.player.currentVolume().toPrecision(2);
        this.textVolume.x = this.textName.x + this.textName.width + 10;

        if (this.isRemoving) {
            this.allTexts.forEach(t => t.tint = 0xEE1100);
        }
    }

    private get allTexts(): PIXI.Text[] {
        return [this.textName, this.textVolume];
    }

    public get isRemoving(): boolean {
        return !!this.removeTL;
    }

    public get isRemoved(): boolean {
        return !this.children.length;
    }

    public remove(): void {
        if (this.isRemoving) return;

        this.removeTL = Helper.setTimeline(this.removeTL, new gsap.core.Timeline({
            onComplete: () => {
                this.destroy({children: true});
            }
        }))

        this.removeTL.to(this, {duration: 2});
        this.removeTL.to(this, {alpha: 0, duration: 0.5});
    }
}
